'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import { isPosthogEnabled } from '@/lib/posthog-client';

export default function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const searchParamsString = searchParams?.toString() ?? '';

  useEffect(() => {
    if (!isPosthogEnabled()) return;

    const url = searchParamsString
      ? `${pathname}?${searchParamsString}`
      : pathname;

    posthog.capture('$pageview', {
      $current_url: `${window.location.origin}${url}`,
    });
  }, [pathname, searchParamsString]);

  return null;
}
